export default __webpack_public_path__ + "static/05-c24de736bb40b140997df9c8c04771ca.jpg";